import { set } from '@/utils/vuex'

export default {
  setToast: set('toast'),
  setLoggedIn: set('loggedIn'),
  setToken: set('token')
}
